import styled from 'styled-components';

export const Container = styled.div`
  > img {
    width: ${props => (props.width ? `${props.width}px` : 'auto')};
    height: ${props => (props.height ? `${props.height}px` : 'auto')};
  }
`;
